import { useMemo } from "react";
import { ShapeLibrary } from "../../types";
import { filterLibrary } from "../../utils";
import { LibraryRow } from "../types";
import { useDeepEqualMemo } from "frontend/hooks/use-deep-memoize";

export const ITEMS_PER_ROW = 4;

function useVirtualizedShapeLibrary(library: ShapeLibrary, filter: string) {
  const filteredLibrary = useMemo(() => {
    return filterLibrary(library, filter);
  }, [library, filter]);
  const memoedLibrary = useDeepEqualMemo(filteredLibrary);

  const flattenedItems = useMemo(() => {
    if (!memoedLibrary) return [];
    return memoedLibrary.groups.flatMap((group) => group?.items?.map((item) => ({ ...item, groupId: group.id })) ?? []);
  }, [memoedLibrary]);

  const rows: LibraryRow[] = [];

  for (let index = 0; index < flattenedItems.length; index += ITEMS_PER_ROW) {
    rows.push({
      libraryId: library.id,
      groupId: flattenedItems[index].groupId,
      rowIndex: index / ITEMS_PER_ROW,
      items: flattenedItems.slice(index, index + ITEMS_PER_ROW),
    });
  }

  return rows;
}

export default useVirtualizedShapeLibrary;
